/* HPH shared newsletter handler (footer + home newsletter sections).

   Why NATIVE submit (not fetch):
   Shopify guards the contact/customer form with an invisible CAPTCHA whose
   token is only injected during a real (native) form submit. A fetch submit
   bypasses that and Shopify returns HTTP 400 "Missing CAPTCHA token", which is
   why the AJAX attempt showed a false "invalid email" error. So we let the form
   submit natively (page reloads with ?customer_posted=true on success).

   Why sessionStorage:
   {% form 'customer' %} sets form.posted_successfully? at PAGE scope, so after
   the reload EVERY newsletter form would light up "Check your inbox" at once
   (home + footer fired together). We tag which form was submitted just before
   the native submit, then on the next load reveal only that form's success.

   Markup contract (per form):
     .hph-footer__newsletter-form / .hph-newsletter__form
       [data-newsletter-field]    -> input+button wrapper (hidden on success)
       [data-newsletter-success]  -> success <p> (starts hidden) */
(function () {
  var SRC_KEY = 'hph_news_src';
  var POSTED = /[?&](customer|contact)_posted=true/;

  function srcOf(form) {
    return form.classList.contains('hph-footer__newsletter-form') ? 'footer' : 'home';
  }

  var forms = document.querySelectorAll('.hph-footer__newsletter-form, .hph-newsletter__form');
  forms.forEach(function (form) {
    form.addEventListener('submit', function () {
      // Do NOT preventDefault - let the native submit carry the CAPTCHA token.
      try { sessionStorage.setItem(SRC_KEY, srcOf(form)); } catch (e) {}
    });
  });

  // After a successful subscribe, reveal only the submitted form's success.
  if (POSTED.test(window.location.search)) {
    var src = null;
    try { src = sessionStorage.getItem(SRC_KEY); sessionStorage.removeItem(SRC_KEY); } catch (e) {}
    var sel = src === 'footer' ? '.hph-footer__newsletter-form'
            : src === 'home' ? '.hph-newsletter__form'
            : null;
    if (sel) {
      var f = document.querySelector(sel);
      if (f) {
        var field = f.querySelector('[data-newsletter-field]');
        var success = f.querySelector('[data-newsletter-success]');
        if (field) field.hidden = true;
        if (success) success.hidden = false;
        success && success.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      // Mark subscribed on this device + remove the "10% off" re-entry points
      // (header pill + drawer row) so the offer disappears after a home/footer subscribe.
      try { localStorage.setItem('hph_news_subscribed', '1'); } catch (e) {}
      var offers = document.querySelectorAll('[data-hph-offer]');
      Array.prototype.forEach.call(offers, function (el) {
        var li = el.closest ? el.closest('.hph-drawer__item') : null;
        (li || el).style.display = 'none';
      });
    }
  }
})();
